import { ModalDialog } from 'commons/components';
import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

/**
 * Mirrors the operators locations modal (`operators-locations-modal.style.tsx`): the shared
 * `ModalDialog` does not size a scrolling list on its own, so the card and content wrappers have to
 * give the list the full height to grow into.
 */
export const RestrictLocationsDialog = styled(ModalDialog)`
    /* OWC-OVERRIDE: the dialog body must be a fixed-height box whose inner list scrolls, not
       the dialog itself. owc-card's content wrapper defaults to overflow:auto and content
       height in v7.6.0, and exposes no overflow or fill-height prop. Revisit on the next @one upgrade. */
    .owc-card .owc-card__content-wrapper {
        overflow: hidden;

        > div {
            height: 100%;
        }
    }

    .modal-dialog-content {
        height: 100%;
    }

    owc-list {
        flex-grow: 1;
    }
`;

export const RestrictLocationsContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${owcTheme['one-spacing-gap-4-xs']};
    width: 100%;
    height: 100%;

    .search-button {
        width: 100%;
    }
`;
